var map = {
	"./Concerto 4-5 ottobre.jpg": 4803,
	"./Concerto22Novembre2025.jpg": 4435,
	"./Locandina natale 2.jpg": 633,
	"./Locandina03012026.jpeg": 2247,
	"./Locandina18_04_2026 .jpeg": 2114,
	"./LocandinaConcerto.jpg": 3107,
	"./LocandinaSottoLeStelle.jpg": 6559,
	"./Natale.jpg": 164,
	"./colorimusica.jpg": 9831,
	"./concerto-Irsina.jpg": 4847,
	"./concerto-messa.jpg": 6852,
	"./concerto30novembre.jpg": 5319,
	"./concerto9novembre.jpg": 5817,
	"./i colori della musica.jpg": 5108,
	"./locandina10gennaio.jpg": 7768,
	"./openday.jpg": 2961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 844;